export const dashboardExplanationLink = 'https://help.pavecommute.app/en/articles/8894990';
export const userRoleArticleLink = 'https://help.pavecommute.app/en/articles/9648714-user-roles';
export const usingTheAppArticleLink = 'https://help.pavecommute.app/en/collections/8042164-using-the-app';
